import Timeout from '../../../utils/Timeout';
import Register from '../../../utils/Register';
import { KeyCodes } from '../../../utils/KeyCodes';
import naja from 'naja';

export default class WithdrawalForm {

	constructor ($form) {
		const _this = this;

		$form.filterAllNodes('.js-spinbox-plus, .js-spinbox-minus').on('click touchend',
			function (event) {
				_this.reloadWithDelay(100, this);
				event.preventDefault();
			}
		);

		$form.filterAllNodes('.js-spinbox-input')
			.blur(function () {
				if ($(this).data('ignore-blur')) {
					$(this).removeData('ignore-blur');
					return;
				}

				if ($(this).val() !== $(this).data('original-value')) {
					_this.reloadWithDelay(100, this);
				}
			})
			.keydown(function (event) {
				if (event.keyCode === KeyCodes.ENTER) {
					$(this).data('ignore-blur', true);
					_this.reloadWithDelay(0, this);
					event.preventDefault();
				}
			}).each(function(index, el) {
				$(this).data('original-value', $(el).val());
			});
	}

	reload ($input) {
		const $form = $input.closest('form');
		const data = new FormData();

		$form.find('.js-spinbox-input').each(function () {
			data.append(this.name, this.value);
		});

		if ($input.val() !== $input.data('original-value')) {
			naja.makeRequest(
				'POST',
				$form.data('url'),
				data,
				{
					history: false
				}
			);
		}
	}

	reloadWithDelay (delay, el) {
		const _this = this;
		const $input = $(el).closest('.js-spinbox').find('input');

		Timeout.setTimeoutAndClearPrevious(
			'orderWithdrawalRecalculator',
			function () {
				_this.reload($input);
			},
			delay
		);
	}

	static init ($container) {
		const $form = $container.find('.js-order-withdrawal-form');
		if ($form.length) {
			new WithdrawalForm($form);
		}
	}

}

(new Register()).registerCallback(WithdrawalForm.init, 'WithdrawalForm.init');